import './page_accessibility_display.less';

import React from 'react';
import VisitorAccessDisplay from 'zoomforth_shared_management/components/visitor_access_display.jsx';
import { WarningIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';


const PageAccessibilityDisplay = ({ page, onVisitorAccessSettingsView, ...props })=> (
  page.isDeactivated() ?
    <div className="page-accessibility-warning-deactivated">
      <WarningIcon /> This site is deactivated. Visitors will see a "not found" (404) message.
    </div>
  :
    <VisitorAccessDisplay
      {...props}
      page={page}
      onVisitorAccessSettingsView={() => { onVisitorAccessSettingsView(page); }}
    />
);


export default PageAccessibilityDisplay;